---
nb:
  errors:
    messages:
      carrierwave_download_error: kunne ikke lastes ned
      carrierwave_integrity_error: er ikke av en tillatt filtype
      carrierwave_processing_error: kunne ikke behandles
      content_type_blacklist_error: Du har ikke lov til å laste opp %{content_type}-filer
      content_type_whitelist_error: 'Du har ikke lov til å laste opp %{content_type}-filer, tillatte typer: %{allowed_types}'
      extension_blacklist_error: 'Du har ikke lov til å laste opp %{extension}-filer, forbudte typer: %{prohibited_types}'
      extension_whitelist_error: 'Du har ikke lov til å laste opp %{extension}-filer, tillatte typer: %{allowed_types}'
      max_size_error: Filstørrelsen må være mindre enn %{max_size}
      min_size_error: Filstørrelsen må være større enn %{min_size}
      mini_magick_processing_error: 'Kunne ikke behandles med MiniMagick, kanskje er det ikke et bilde? Opprinnelig feil: %{e}'
      rmagick_processing_error: Kunne ikke behandles med rmagick, kanskje er det ikke et bilde?
